import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Migrate your test data</h1>
              <p>You can move existing test data into your new team.</p>
              <p>Collaborators have the option to move tests into the team account. Head back to your personal account workspace by finding it in the main menu and clicking on it.  It will be your email:</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528949833/teams/personal-workspace.png" style={{"max-width": "200px"}} /></p>              
              <p>To move entire test folders, find the "move" icon next to it, and follow the prompts.  This will copy all tests and any dependent components from within those tests.</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528949408/teams/copy-to-org.png" style={{"max-width": "400px"}} /></p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528949406/teams/select-copy-to-org.png" style={{"max-width": "400px"}} /></p>
              <p>To move individual tests, you can use the quick dropdown.</p>
              <p>Just remember, that they won't copy components that compose the test:</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528950009/teams/copy-move-indiv.png" style={{"max-width": "200px"}} /></p>
              <p>Finally, moving environments is quite easy as well:</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528950333/teams/copy-move-env.png" style={{"max-width": "400px"}} /></p>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/migrate.js